export enum DrawerType {
  NEW_ADDITIONAL_INFO = "new",
  EDIT_ADDITIONAL_INFO = "edit",
}

export const DEFAULT_DRAWER_STATE = {
  visible: false,
  title: "",
  type: DrawerType.NEW_ADDITIONAL_INFO,
  fieldName: "",
};